import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

const tagFields = ["statuses"]

export const KeyIssueFilterModel = new Record({
    name: "",
    statuses: [],
    empty: false
})

export const updateKeyIssueSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
